import { ClickAndReserve } from "../../../../FeatureConfigs/ClickAndReserve/feature-config.enum.js";
import { useFeatureToggles } from "../../../../../../FeatureToggles/Context/FeatureToggles/Context/Context.js";
const useClickAndReserveFeatureConfig = () => {
  const { featureConfigs, isClickAndReserveEnabled } = useFeatureToggles();
  if (isClickAndReserveEnabled) {
    if (featureConfigs?.clickAndReserve === ClickAndReserve.STOCK) {
      return "stock_only";
    } else if (featureConfigs?.clickAndReserve === ClickAndReserve.STOCK_RESERVATION) {
      return "reservation";
    }
  }
};
export {
  useClickAndReserveFeatureConfig
};
//# sourceMappingURL=use-click-and-reserve-feature-config.js.map
